import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../ab_testing/ab_testing_instance";
import {HidePricesVariant, OngoingABTests} from "../ab_testing/ongoing_ab_tests";

const hidePricesAbTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.HIDE_PRICES_AND_REGISTER);

export const useHidePricesAbTest = () => {
    const {abTestVariant} = useABTest(hidePricesAbTestInstance);

    return {
        abTestVariant,
        isVisibleVariant: abTestVariant === HidePricesVariant.VISIBLE,
        isHiddenVariant: abTestVariant === HidePricesVariant.HIDDEN,
        isVisibleWithCompleteProfileVariant: abTestVariant === HidePricesVariant.VISIBLE_WITH_COMPLETE_PROFILE
    };
};
import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../ab_testing/ab_testing_instance";
import {HidePricesVariant, OngoingABTests} from "../ab_testing/ongoing_ab_tests";

const hidePricesAbTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.HIDE_PRICES_AND_REGISTER);

export const useHidePricesAbTest = () => {
    const {abTestVariant} = useABTest(hidePricesAbTestInstance);

    return {
        abTestVariant,
        isVisibleVariant: abTestVariant === HidePricesVariant.VISIBLE,
        isHiddenVariant: abTestVariant === HidePricesVariant.HIDDEN,
        isVisibleWithCompleteProfileVariant: abTestVariant === HidePricesVariant.VISIBLE_WITH_COMPLETE_PROFILE
    };
};
